import { UPDATE_VENDOR } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_VENDOR.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_VENDOR.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_VENDOR.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
